import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { ButtonModule } from 'primeng/button';
import { environment } from '../../../environments/environment';
import { routesPath } from '../../core/constants/app.constants';

@Component({
  selector: 'app-login',
  imports: [CommonModule,ButtonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  standalone:true
})
export class LoginComponent implements OnInit {

    flgLoadLoginForm = false;
    
    labelBtnInicioInicial:string = 'Iniciar Sesión';
    labelBtnInicio:string = '';
    flgIniciandoSesion:boolean = false;

    constructor(
        private router: Router,
        private msalService: MsalService) {
        this.labelBtnInicio = this.labelBtnInicioInicial;
    }

    async ngOnInit() {

      try {
        const activeAccount = this.msalService.instance.getActiveAccount()

        if(activeAccount){
          this.router.navigate(['/'+ routesPath.inicio]);
        }else{
          //Ejecutar el handler
          await this.msalService.instance.handleRedirectPromise().then(async (authResult: AuthenticationResult | null) => {
              const accounts = this.msalService.instance.getAllAccounts();
              if(accounts.length > 0){
                this.msalService.instance.setActiveAccount(accounts[0]);
                this.router.navigate(['/'+ routesPath.inicio]);
              }else{
                this.flgLoadLoginForm = true;
              }
          });
        }

      } catch (err) {
        this.flgLoadLoginForm = true;
        console.error('Error al iniciar sesión:', err);
      }
    }

    async fnLogin(){
      try {
        this.labelBtnInicio = 'Iniciando Sesión';
        this.flgIniciandoSesion = true;
        await this.msalService.instance.loginRedirect({
            scopes: environment.appFrontend.redirect.scopes,
            redirectUri: environment.appFrontend.redirect.url
        });
      } catch (err) {
        this.labelBtnInicio = this.labelBtnInicioInicial;
        this.flgIniciandoSesion = false;
        console.error('Error al iniciar sesión:', err);
      }

    }

}